export const IMAGES = {
  solarHero: "https://images.unsplash.com/photo-1723133371535-1412bc2e412e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  solarField: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  substation: "https://images.unsplash.com/photo-1509391111737-9b07f052f6b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  transformer: "https://images.unsplash.com/photo-1509390144018-eeaf65052242?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  miningHero: "https://images.unsplash.com/photo-1711012604128-8339024a3e12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  miningPit: "https://images.unsplash.com/photo-1680463990599-9d318aaecf71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  miningTruck: "https://images.unsplash.com/photo-1709489662983-3674d790b224?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  mediaHero: "https://images.pexels.com/photos/7900581/pexels-photo-7900581.jpeg?auto=compress&cs=tinysrgb&w=1600",
  mediaStudio: "https://images.pexels.com/photos/33354214/pexels-photo-33354214.jpeg?auto=compress&cs=tinysrgb&w=1600",
  building: "https://images.unsplash.com/photo-1576731753569-3e93a228048c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const NAV = [
  { key: "home", path: "/" },
  { key: "solar", path: "/solar" },
  { key: "media", path: "/media" },
  { key: "mining", path: "/mining" },
  { key: "calculator", path: "/solar-calculator" },
  { key: "gallery", path: "/gallery" },
  { key: "operations", path: "/operations" },
  { key: "investors", path: "/investors" },
  { key: "esg", path: "/esg" },
  { key: "careers", path: "/careers" },
  { key: "download", path: "/download" },
  { key: "contact", path: "/contact" },
];

export const ABOUT_LINKS = [
  ["About Company", "/about#company"],
  ["Board Member Details", "/about#board"],
  ["Project", "/about#projects"],
  ["Vision", "/about#vision"],
  ["Mission", "/about#mission"],
  ["Organization Hierarchy", "/about#hierarchy"],
];

export const ADMIN_NAV = [
  { key: "Dashboard", path: "/admin", icon: "LayoutDashboard" },
  { key: "Content", path: "/admin/content", icon: "FileText" },
  { key: "Media Gallery", path: "/admin/media", icon: "Image" },
  { key: "Messages", path: "/admin/messages", icon: "Mail" },
  { key: "Applications", path: "/admin/applications", icon: "Briefcase" },
  { key: "Visitor Passes", path: "/admin/visitors", icon: "QrCode" },
  { key: "Projects / GIS", path: "/admin/projects", icon: "Map" },
  { key: "Pages & Content", path: "/admin/site-editor", icon: "LayoutPanelTop" },
  { key: "Roles & Audit", path: "/admin/roles", icon: "ShieldCheck" },
];
